import { hookstate } from "@hookstate/core";
import { ReaderNavigationContext } from "../screens/reader/types";

export const readerNavigationContext = hookstate<ReaderNavigationContext>({});
